<template>
  <step-container heading="Campaigns">
    <template v-slot:description>
      <p>Campaigns are used to track your marketing efforts. This will allow you to see what efforts are giving you the
        most leads that turn into deals.</p>

      <p>As you start using Forefront you'll want to add costs to your campaigns. Doing so will allow you to know
        exactly how much each lead and deal cost you in marketing spend.</p>

      <p>And for campaigns that have units like mail pieces you can keep track of how many units you send with unit
        counts.</p>
    </template>

    <div class="flex flex-between flex-vertical-end mb-200">
      <form-field-select
        label="Channel"
        class="mb-0"
        v-model="form.channel"
      >
        <option
          v-for="channel in channelEnum"
          :key="channel.value"
          :value="channel.value"
        >{{ channel.label }}
        </option>
      </form-field-select>

      <form-field-input
        label="Label"
        class="mb-0 mx-150 flex-grow"
        v-model="form.label"
      ></form-field-input>

      <div class="mt-100 flex flex-end">
        <button-outlined @click="addCampaign">Add Campaign</button-outlined>
      </div>
    </div>

    <div class="flex-grow">
      <h3 class="has-text-weight-bold is-size-5 mb-100">Campaigns to Add:</h3>

      <template v-if="campaignsWithLabel.length">
        <step-item-campaign
          v-for="(campaign, index) in campaignsWithLabel"
          :key="index"
          :campaign="campaign"
        />
      </template>

      <p v-else class="mt-200 is-italic">There are no campaigns to add</p>
    </div>
  </step-container>
</template>

<script>
import {defineComponent} from 'vue'
import StepContainer from "../component/StepContainer.vue";
import CampaignForm from "../../../forms/CampaignForm.vue";
import {ENUMS} from "../../../services/enums";
import StepItemCampaign from "../component/StepItemCampaign.vue";

export default defineComponent({
  name: "OnboardingStepCampaign",
  components: {StepItemCampaign, CampaignForm, StepContainer},
  data() {
    return {
      form: {
        channel: null,
        label: null,
      },
      channelEnum: ENUMS.CampaignChannelEnum,
    }
  },
  computed: {
    campaigns() {
      return this.$store.state.onboarding.provisionData.campaigns;
    },
    campaignsWithLabel() {
      return this.campaigns.map(campaign => {
        const channelLabel = this.getChannelLabel(campaign.channel);

        return {
          ...campaign,
          channelLabel: channelLabel,
        }
      })
    }
  },
  methods: {
    addCampaign() {
      this.$store.commit('onboarding/addCampaign', this.form);

      this.form = {
        channel: null,
        label: null,
      }
    },
    getChannelLabel(channelValue) {
      const keys = Object.keys(this.channelEnum);
      let selectedChannel = null;

      keys.forEach(key => {
        const channel = this.channelEnum[key];
        if (channel.value === channelValue) selectedChannel = channel;
      })

      if (selectedChannel) return selectedChannel.label;

      return null;
    }
  },
})
</script>

<style scoped lang="scss">

</style>
